import { LongTextAnswer, RadioBooleanAnswer, TextAnswer } from './anwer-types';
import { useReport, useSection } from './hooks/use-context';
import { AnswerData, QuestionData } from './types';

export function InitialInfos() {
  const { questions } = useSection();
  const { header } = useReport();

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        maxWidth: '950px',
        marginBottom: '10px',
        paddingBottom: '12px',
        borderBottom: '2px solid #DEC8B3',
        color: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: '#E0F4E9',
          padding: '10px',
          marginBottom: '6px',
        }}
      >
        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Data:',
                answers: [{ content: header.event_finished_at } as AnswerData],
              } as QuestionData
            }
          />

          {[
            '3982ce73-984a-4a9c-a42a-0afb21e50b7a',
            'b0e4699f-6c5c-4f01-b0cd-ed6353b2be9d',
          ].map((questionId) => {
            const question = questions.find(
              (question) => question.question_id === questionId,
            );

            return question && <TextAnswer question={question} />;
          })}

          <TextAnswer
            question={
              {
                name: 'Preenchido por:',
                answers: [{ content: header.author_full_name } as AnswerData],
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          {questions.find(
            (question) =>
              question.question_id === 'f074913a-4da3-4ad5-9be1-7233f53ff342',
          ) && (
            <TextAnswer
              question={
                questions.find(
                  (question) =>
                    question.question_id ===
                    'f074913a-4da3-4ad5-9be1-7233f53ff342',
                )!
              }
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          {questions.find(
            (question) =>
              question.question_id === '793cfc5f-0c14-4d83-8cb1-1fdae56113d8',
          ) && (
            <TextAnswer
              question={
                questions.find(
                  (question) =>
                    question.question_id ===
                    '793cfc5f-0c14-4d83-8cb1-1fdae56113d8',
                )!
              }
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          {questions.find(
            (question) =>
              question.question_id === 'c2138566-25ad-4e7e-ac6f-96ada81fabbf',
          ) && (
            <TextAnswer
              question={
                questions.find(
                  (question) =>
                    question.question_id ===
                    'c2138566-25ad-4e7e-ac6f-96ada81fabbf',
                )!
              }
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          {questions.find(
            (question) =>
              question.question_id === '95eded4d-7aac-47af-84e3-7894f5eadd27',
          ) && (
            <RadioBooleanAnswer
              question={
                questions.find(
                  (question) =>
                    question.question_id ===
                    '95eded4d-7aac-47af-84e3-7894f5eadd27',
                )!
              }
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          {questions.find(
            (question) =>
              question.question_id === '544d2a99-59bb-44f8-a3f1-7efda9c0a8a7',
          ) && (
            <LongTextAnswer
              question={
                questions.find(
                  (question) =>
                    question.question_id ===
                    '544d2a99-59bb-44f8-a3f1-7efda9c0a8a7',
                )!
              }
            />
          )}
        </div>
      </div>

      <div
        style={{
          fontFamily: 'Arial, sans-serif',
          fontSize: '12px',
          color: '#333',
        }}
      >
        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          Questionamentos
        </div>

        <div style={{ marginBottom: '8px' }}>
          <span style={{ fontWeight: 'bold' }}>Legenda:</span> F = Frequência, A
          = Abrangência, P = Probabilidade do dano, S = Severidade.
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontWeight: 'bold' }}>
            Usar planilha de classificação HRN para fazer avaliação e lista de
            perigos e riscos
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '1px solid #999',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#555',
              }}
            >
              ✕
            </div>
            <div style={{ fontSize: '12px', color: '#555' }}>
              = Opção Selecionada
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
